import React from 'react';
import { getOpenInBrowserUrl } from '../utils/emailPreviewContext';

const logoUrl = `${process.env.PUBLIC_URL || ''}/web-app-manifest-512x512.png`;

const styles = {
  page: {
    minHeight: '100dvh',
    margin: 0,
    background:
      'radial-gradient(ellipse 70% 35% at 50% 0%, rgba(211,47,47,0.07) 0%, transparent 70%), #F9FAFB',
    fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Inter', 'Roboto', sans-serif",
    color: '#1E1E1E',
    WebkitFontSmoothing: 'antialiased',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 'max(2.5rem, env(safe-area-inset-top, 0px)) 1.25rem calc(2rem + env(safe-area-inset-bottom, 0px))',
    boxSizing: 'border-box',
  },
  inner: {
    width: '100%',
    maxWidth: 420,
    textAlign: 'center',
  },
  logo: {
    width: 72,
    height: 72,
    objectFit: 'contain',
    borderRadius: 12,
    border: '1px solid rgba(0,0,0,0.06)',
    background: '#fff',
    margin: '0 auto 1.25rem',
    display: 'block',
  },
  eyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    background: '#FFF1F1',
    color: '#D32F2F',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    borderRadius: 999,
    padding: '6px 12px',
    marginBottom: 14,
    border: '1px solid rgba(211, 47, 47, 0.12)',
  },
  title: {
    fontSize: 'clamp(1.35rem, 5vw, 1.65rem)',
    fontWeight: 700,
    lineHeight: 1.25,
    margin: '0 0 12px',
    letterSpacing: '-0.01em',
  },
  text: {
    fontSize: 15,
    lineHeight: 1.65,
    color: '#6B6B6B',
    margin: '0 0 1.5rem',
  },
  card: {
    background: '#fff',
    border: '1px solid rgba(0,0,0,0.08)',
    borderRadius: 16,
    padding: '18px 16px',
    textAlign: 'left',
    boxShadow: '0 6px 18px rgba(15, 23, 42, 0.06)',
    marginBottom: '1.5rem',
  },
  step: {
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start',
    marginBottom: 14,
  },
  stepNum: {
    flexShrink: 0,
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: '#1E1E1E',
    color: '#fff',
    fontSize: 13,
    fontWeight: 700,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  stepBody: {
    fontSize: 14,
    lineHeight: 1.55,
    color: '#3A3A3A',
    paddingTop: 2,
  },
  cta: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 360,
    padding: '16px 24px',
    borderRadius: 999,
    border: 'none',
    background: 'linear-gradient(135deg, #B71C1C, #D32F2F)',
    color: '#fff',
    fontWeight: 700,
    fontSize: 17,
    fontFamily: 'inherit',
    textDecoration: 'none',
    boxShadow: '0 10px 24px rgba(183,28,28,0.28)',
    cursor: 'pointer',
  },
  hint: {
    marginTop: 12,
    fontSize: 12,
    lineHeight: 1.55,
    color: '#6B6B6B',
  },
};

export default function OpenInBrowserScreen() {
  const openUrl = getOpenInBrowserUrl();

  return (
    <main style={styles.page}>
      <div style={styles.inner}>
        <img src={logoUrl} alt="Consulta+" style={styles.logo} width={72} height={72} />
        <span style={styles.eyebrow}>Consulta Mais</span>
        <h1 style={styles.title}>Abra no navegador para continuar</h1>
        <p style={styles.text}>
          Você está vendo uma prévia dentro do e-mail. Para usar o site com segurança — cadastro,
          chat médico e demais telas — abra no Chrome, Safari ou no navegador do celular.
        </p>

        <div style={styles.card}>
          <div style={styles.step}>
            <span style={styles.stepNum} aria-hidden="true">1</span>
            <div style={styles.stepBody}>
              Toque em <strong>Abrir no navegador</strong> abaixo.
            </div>
          </div>
          <div style={styles.step}>
            <span style={styles.stepNum} aria-hidden="true">2</span>
            <div style={styles.stepBody}>
              Se o celular perguntar, escolha <strong>Chrome</strong> ou <strong>Safari</strong>.
            </div>
          </div>
          <div style={{ ...styles.step, marginBottom: 0 }}>
            <span style={styles.stepNum} aria-hidden="true">3</span>
            <div style={styles.stepBody}>
              Continue de onde parou — o link mantém sua página atual.
            </div>
          </div>
        </div>

        <a
          href={openUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.cta}
        >
          Abrir no navegador
        </a>
        <p style={styles.hint}>
          Dica: no Gmail, use o ícone ⋮ ou “Abrir no navegador” no canto superior.
        </p>
      </div>
    </main>
  );
}
